// extracted by mini-css-extract-plugin
module.exports = {"intro":"TestimonianzeSection_intro__Ls0Oj","title":"TestimonianzeSection_title__sA8se","list":"TestimonianzeSection_list__Jpoq8","item":"TestimonianzeSection_item__oGBR3"};